import React from 'react';
import {ArrowUpRight, Dot} from 'lucide-react';
import {useI18n} from '../../i18n/useI18n';
import {StoryBlock} from '../../pages/site/site.types';
import styles from './styles/SplitShowcase.module.css';

interface SplitShowcaseProps {
    block: StoryBlock;
    reverse?: boolean;
}

const SplitShowcase: React.FC<SplitShowcaseProps> = ({block, reverse = false}) => {
    const {t} = useI18n();

    return (
        <section className={`${styles.wrap} ${reverse ? styles.reverse : ''}`}>
            <article className={`site-card ${styles.copyCard}`}>
                <span className="site-eyebrow">{block.cardEyebrow ?? block.eyebrow}</span>
                <h3>{block.cardTitle ?? block.title}</h3>
                <p>{block.cardDescription ?? block.description}</p>
                <div className={styles.bullets}>
                    {block.bullets.map(item => (
                        <div className={styles.bullet} key={item}>
                            <ArrowUpRight size={16}/>
                            <span>{item}</span>
                        </div>
                    ))}
                </div>
            </article>
            <article className={`site-card ${styles.visualCard}`}>
                <div className={styles.visualHeader}>
                    <span>{t('site.splitShowcase.panel')}</span>
                    <span className={styles.badge}>{t('site.splitShowcase.structured')}</span>
                </div>
                <div className={styles.visualBody}>
                    {block.metrics.map(metric => (
                        <div className={styles.visualMetric} key={`${metric.title}-${metric.value}`}>
                            <span>{metric.title}</span>
                            <strong>{metric.value}</strong>
                            <small>
                                <Dot size={18}/>
                                <span>{metric.note}</span>
                            </small>
                        </div>
                    ))}
                </div>
            </article>
        </section>
    );
};

export default SplitShowcase;
